<template>
    <div>
        <ItemSelector
            :submission="submission" 
            :submission_id="submission_id" 
            :post_id="post_id" 
            :item_id="item_id" 
            :submit_url="submit_url" 
            :return_url="return_url" 
            :original="item" 
            :item="item ? item.data : {}" 
            :ingredients="ingredients" 
            :live="true"
            :app_locale="app_locale"
            :is_open="true"
            @submit="submit"
        ></ItemSelector>

        <form method="post" ref="theform" :action="submit_url">
            <input type="hidden" name="postid" :value="post_id" />
            <input type="hidden" name="itemid" :value="item_id" />
            <input type="hidden" name="itemtitle" :value="item.name" />
            <input type="hidden" name="total" :value="total" />
            <input type="hidden" name="remarks" :value="remarks" />
            <input type="hidden" name="submission_id" :value="sid" />
    
        </form>
        
    </div>
</template>

<script>
import ItemSelector from "../../components/ItemSelector";

export default {
  name: "Item",
    props: ['item', 'app_locale', 'return_url', 'submit_url', 'ingredients', 'submission_id', 'submission', 'post_id', 'item_id'],
    components: {ItemSelector},
    data() {
        return {
            total: 0,
            remarks: '',
            sid: this.submission_id,
        }
    },
    methods: {
      submit(ev) {
          const { total, remarks, submission_id } = ev;
          this.total = total;
          this.remarks = remarks;
          this.sid = submission_id;
          
          setTimeout(() => {
              this.$refs.theform.submit();
          }, 100)
      }
    }
    
}
</script>

<style scoped>

</style>
